import { errorToastAction } from 'utils';

const errorCb = (defaultReturn, errMsg, dispatch) => message => {
	dispatch(errorToastAction(`${errMsg} ${message}`));
	return defaultReturn;
};

export default errorCb;
